export default __webpack_public_path__ + "static/media/ER6.51548187.png";